"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  QuickActions: () => QuickActions
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var import_validate = require("./validate");
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneQuickActions");
  return hybrid;
}
function setItems(items) {
  (0, import_validate.assertQuickActionItems)(items);
  return native().setItems(items).catch(import_nativeError.rethrowNativeError);
}
function getItems() {
  return native().getItems().catch(import_nativeError.rethrowNativeError);
}
function getInitialAction() {
  var _native_getInitialAction;
  return (_native_getInitialAction = native().getInitialAction()) !== null && _native_getInitialAction !== void 0 ? _native_getInitialAction : null;
}
function clearInitialAction() {
  native().clearInitialAction();
}
function addListener(listener) {
  (0, import_validate.assertQuickActionListener)(listener);
  return native().addListener(listener);
}
var QuickActions = Object.freeze({
  setItems,
  getItems,
  getInitialAction,
  clearInitialAction,
  addListener
});
//# sourceMappingURL=index.native.js.map
